import DescriptionLink from "./DescriptionLink";

export default DescriptionLink;
